import * as tslib_1 from "tslib";
import { ApiService } from "./api.service";
var AppService = /** @class */ (function () {
    function AppService(apiService) {
        this.apiService = apiService;
        this.loading = "";
        this.notification = "test";
        this.notificationClass = "";
        this.notificationTimer = null;
        this.CONFIG_STORAGE_KEY = 'app_config';
    }
    Object.defineProperty(AppService, "config", {
        // Getter that automatically loads config if null
        get: function () {
            return AppService._config;
        },
        // Setter for config
        set: function (value) {
            AppService._config = value;
        },
        enumerable: true,
        configurable: true
    });
    // Method to safely get config with automatic loading
    AppService.prototype.getConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!AppService.config) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadConfig()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, AppService.config];
                }
            });
        });
    };
    AppService.prototype.loadConfig = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // First try to load from localStorage
            var savedConfig = _this.loadConfigFromStorage();
            if (savedConfig) {
                AppService.config = savedConfig;
                resolve();
                return;
            }
            // Fallback to loading from API/assets
            _this.apiService.loadAppConfig().subscribe(function (config) {
                AppService.config = config;
                // Save to localStorage for future use
                _this.saveConfigToStorage(config);
                resolve();
            }, function (error) {
                console.error('Failed to load app config:', error);
                reject(error);
            });
        });
    };
    AppService.prototype.changeConfig = function (config) {
        AppService.config = config;
        // Save configuration to localStorage for persistence
        this.saveConfigToStorage(config);
        // Show notification that config was saved
        this.showNotification('Configuration saved successfully');
    };
    AppService.prototype.saveConfigToStorage = function (config) {
        try {
            var configString = JSON.stringify(config, null, 2);
            localStorage.setItem(this.CONFIG_STORAGE_KEY, configString);
        }
        catch (error) {
            console.error('Failed to save config to localStorage:', error);
        }
    };
    AppService.prototype.loadConfigFromStorage = function () {
        try {
            var configString = localStorage.getItem(this.CONFIG_STORAGE_KEY);
            if (configString) {
                return JSON.parse(configString);
            }
        }
        catch (error) {
            console.error('Failed to load config from localStorage:', error);
        }
        return null;
    };
    AppService.prototype.showNotification = function (s) {
        var _this = this;
        if (this.notificationTimer) {
            clearTimeout(this.notificationTimer);
        }
        this.notification = s;
        this.notificationClass = "active";
        this.notificationTimer = setTimeout(function () {
            _this.notificationClass = "";
            _this.notificationTimer = null;
        }, 2000);
    };
    AppService._config = null;
    return AppService;
}());
export { AppService };
